import React from "react";
import PermitApprovers from "../PermitApprovers";
import { WorkPermitApprover } from "../../../constants/common";
import StickerIDCardDetails from "./StickerIDCardDetails";
import Wrapper from "../Wrapper";

interface LostVehicleStickerIDCardPermitPDFProps {
  permitDetails: {
    s_StickerNumber: string;
    s_CopyNumber: string;
    approvers: WorkPermitApprover[];
  };
}

const LostVehicleStickerIDCardPermitPDF: React.FC<LostVehicleStickerIDCardPermitPDFProps> = ({
  permitDetails,
}) => {
  return (
    <Wrapper title="Lost Vehicle Sticker/ID Card">
      <StickerIDCardDetails permitDetails={permitDetails} />
      <PermitApprovers sectionNumber={2} approvers={permitDetails?.approvers} />
    </Wrapper>
  );
};

export default LostVehicleStickerIDCardPermitPDF;
